export class DirectoryListing {
    public contents: string[];

    public constructor() {
        this.contents = [];
    }
}
